import React from "react";
import { Modal, Form,  Button,  } from "antd";
import TextInput from "../../ReusableInputs/TextInput";
import TextAreaInput from "../../ReusableInputs/TextAreaInput";

import { labelStyle } from "../../../@types/productInfo";
import ToggleSwitch from "../../ui/toggle";


interface WaterMachineModalProps {
  onClose: () => void;

  isProcessing: boolean;
  isUpdating: boolean;

  name: string;
  setName: (value: string) => void;
  is_new: boolean;
  setIsnew: (value: boolean) => void; 
  description: string;
  setDescription: (value: string) => void;
  metaTitle: string;
  setMetaTitle: (value: string) => void;
  metaDescription: string;
  setMetaDescription: (value: string) => void;
  video: string;
  setVideo: (value: string) => void;
  imagesBlack: string[];
  setImagesBlack: (value: string[]) => void;
  imagesWhite: string[];
  setImagesWhite: (value: string[]) => void;
  selectedRole: string;
  setSelectedRole: (value: string) => void;
  selectedMachine: any;
  setSelectedMachine: (value: any) => void;
  machineLink: string;
  setMachineLink: (value: string) => void;
  price: number | string;
  setPrice: (value: string) => void;
  sku: string;
  setSku: (value: string) => void;
  isModalVisible: boolean;
  height: string;
  setHeight: (value: string) => void;
  width: string;
  setWidth: (value: string) => void;
  length: string;
  setLength: (value: string) => void;
  weight: string;
  setWeight: (value: string) => void;
  images_black: string[];
  images_white: string[];
  handleFormSubmit: (value: any) => void;
  handleSaveEdit: (value: any) => void;
  handleFileChangeVideo: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  handleFileChangeImage: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
}

const WaterMachineModal: React.FC<WaterMachineModalProps> = ({
  onClose,
  images_black,
  images_white,
  isProcessing,
  name,
  setName,
  description,
  setDescription,
  metaTitle,
  setMetaTitle,
  metaDescription,
  setMetaDescription,
  video,
  setVideo,
  imagesBlack,
  setImagesBlack,
  imagesWhite,
  setImagesWhite,
  selectedRole,
  setSelectedRole,
  selectedMachine,
  setSelectedMachine,
  machineLink,
  setMachineLink,
  price,
  setPrice,
  sku,
  setSku,
  isUpdating,
  handleSaveEdit,
  handleFormSubmit,
  height,
  setHeight,
  width,
  setWidth,
  length,
  setLength,
  weight,
  setWeight,
  isModalVisible,
  handleFileChangeImage,
  handleFileChange,
  handleFileChangeVideo,
  is_new,
  setIsnew
}) => {
  const [form] = Form.useForm();

  const handleRemoveImageBlack = (index: number) => {
    const updatedImages = images_black.filter((_, i) => i !== index);
    setImagesBlack(updatedImages);
  };

  const handleRemoveImageWhite = (index: number) => {
    const updatedImages = images_white.filter((_, i) => i !== index);
    setImagesWhite(updatedImages);
  };

  const handleRemoveVideo = () => {
    setVideo("");
  };
  return (
    <Modal
      title="Add or Update Water Machine"
      visible={isModalVisible}
      onCancel={onClose}
      footer={null}
      width={700}
      bodyStyle={{ maxHeight: "550px", overflowY: "auto" }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={() => {
          if (isUpdating) {
            handleSaveEdit({
              name,
              description,
              metaTitle,
              metaDescription,
              video,
              images_black,
              images_white,
              selectedRole,
              selectedMachine,
              machine_link: machineLink,
              price,
              sku,
              is_new,
            });
          } else {
            handleFormSubmit({
              name,
              description,
              metaTitle,
              metaDescription,
              video,
              images_black,
              images_white,
              selectedRole,
              selectedMachine,
              machineLink,
              price,
              sku,
              is_new
            });
          }
        }}>
        <ToggleSwitch
          initialState={is_new}
          activeColor="#75A7AD"
          inactiveColor="gray-300"
          size="default"
          label="Mark as New"
          onChange={(state) => setIsnew(state)}   
          disabled={false}
          className="my-4"
        />

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Name"
              placeholder="Enter name"
              inputValue={name}
              setInputValue={setName}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Price"
              placeholder="Enter price"
              inputValue={price.toString()}
              setInputValue={setPrice}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Water Machine Link"
              placeholder="Enter name water machine link"
              inputValue={machineLink}
              setInputValue={setMachineLink}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="SKU"
              placeholder="Enter SKU"
              inputValue={sku}
              setInputValue={setSku}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Meta Title"
              placeholder="Enter meta title"
              inputValue={metaTitle}
              setInputValue={setMetaTitle}
            />
          </div>
        </section>

        <section className=" md:flex-row md:space-x-4 ">
          <TextAreaInput
            title="Description"
            placeholder="Enter description"
            inputValue={description}
            setInputValue={setDescription}
          />
        </section>

        <section className=" md:flex-row md:space-x-4">
          <TextAreaInput
            title="Description"
            placeholder="Enter description"
            inputValue={metaDescription}
            setInputValue={setMetaDescription}
          />
        </section>

        {/*  */}
        <section className="md:flex-row md:space-x-4 mt-[20px]">
          <div>
            <label
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              htmlFor="file_input">
              Upload White Images
            </label>
            <input
              className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
              aria-describedby="file_input_help"
              type="file"
              id="image-upload"
              accept="image/*"
              onChange={handleFileChangeImage}
              multiple
            />
            <p
              className="mt-1 text-sm text-gray-500 dark:text-gray-300"
              id="file_input_help">
              SVG, PNG, JPG or GIF (MAX. 800x400px).
            </p>
          </div>

          <div
            style={{
              height: "118px",
              width: "100%",
              maxHeight: "120px",
              overflowY: "auto",
            }}
            className="block rounded-lg bg-white mt-[3%]
             shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700">
            <div
              className="overflow-hidden"
              style={{ maxHeight: "370px", overflowY: "auto" }}>
              {images_white.length > 0 ? (
                <ul
                  className="max-w-md divide-y divide-gray-200 
                dark:divide-gray-700 flex flex-wrap flex-wrap-wrap
                 overflow-y-auto">
                  {images_white.map((black, index) => (
                    <div key={index} className="w-1/3">
                      <div className="flex items-center">
                        <p
                          className="text-xs font-medium text-gray-900 
                        truncate dark:text-white">
                          <img
                            src={black}
                            alt=""
                            className="object-cover border border-solid 
                            border-white"
                            style={{
                              height: "100px",
                              width: "100%",

                              overflowY: "auto",
                            }}
                          />
                        </p>
                      </div>
                      <Button
                        onClick={() => handleRemoveImageWhite(index)}
                        className="mt-2 bg-red-500 text-white"
                        size="small">
                        Remove
                      </Button>
                      <div className="flex items-center"></div>
                    </div>
                  ))}
                </ul>
              ) : (
                <p className=" mt-[10%]  text-black font-bold">
                  No White Images uploaded yet
                </p>
              )}
            </div>
          </div>
        </section>

        <section className="md:flex-row md:space-x-4 mt-[20px]">
          <div>
            <label
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              htmlFor="file_input">
              Upload Black Images
            </label>
            <input
              className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
              aria-describedby="file_input_help"
              type="file"
              id="image-upload"
              accept="image/*"
              onChange={handleFileChange}
              multiple
            />
            <p
              className="mt-1 text-sm text-gray-500 dark:text-gray-300"
              id="file_input_help">
              SVG, PNG, JPG or GIF (MAX. 800x400px).
            </p>
          </div>

          <div
            style={{
              height: "118px",
              width: "100%",
              maxHeight: "120px",
              overflowY: "auto",
            }}
            className="block rounded-lg bg-white mt-[3%]
             shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] dark:bg-neutral-700">
            <div
              className="overflow-hidden"
              style={{ maxHeight: "370px", overflowY: "auto" }}>
              {images_black.length > 0 ? (
                <ul
                  className="max-w-md divide-y divide-gray-200 
                dark:divide-gray-700 flex flex-wrap flex-wrap-wrap
                 overflow-y-auto">
                  {images_black.map((black, index) => (
                    <div key={index} className="w-1/3">
                      <div className="flex items-center">
                        <p
                          className="text-xs font-medium text-gray-900 
                        truncate dark:text-white">
                          <img
                            src={black}
                            alt=""
                            className="object-cover border border-solid 
                            border-white"
                            style={{
                              height: "100px",
                              width: "100%",

                              overflowY: "auto",
                            }}
                          />
                        </p>
                      </div>
                      <Button
                        onClick={() => handleRemoveImageBlack(index)}
                        className="mt-2 bg-red-500 text-white"
                        size="small">
                        Remove
                      </Button>
                      <div className="flex items-center"></div>
                    </div>
                  ))}
                </ul>
              ) : (
                <p className=" mt-[10%]  text-black font-bold">
                  No black Images uploaded yet
                </p>
              )}
            </div>
          </div>
        </section>

        {/*  */}

        <div className="flex flex-col w-full mt-[2px] ">
          <label
            style={labelStyle as React.CSSProperties}
            htmlFor="Product Name"
            className="text-gray-600 m-3 font-bold text-sm">
            Video Preview
          </label>

          <input
            className="block w-full text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
            id="dropzone-file-1"
            type="file"
            accept="video/*"
            onChange={handleFileChangeVideo}
            multiple
          />
        </div>

        {video ? (
          <div>
            <video controls width="180" height="70">
              <source src={video} type="video/mp4" />
            </video>
            <p
              className=" mt-[5px] justify-start text-left  text-red-800 cursor-pointer underline text-sm"
              onClick={handleRemoveVideo}>
              Change Video
            </p>
          </div>
        ) : (
          <p className=" p-2 overflow-hidden z-50 mt-[11%] bg-white ml-[120px] text-s text-center justify-center text-black font-bold">
            No video uploaded yet
          </p>
        )}

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Height"
              placeholder="Enter height"
              inputValue={height}
              setInputValue={setHeight}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Width"
              placeholder="Enter width"
              inputValue={width}
              setInputValue={setWidth}
            />
          </div>
        </section>

        <section className="flex flex-col md:flex-row md:space-x-4">
          <div className="w-full p-2">
            <TextInput
              title="Length"
              placeholder="Enter length"
              inputValue={length}
              setInputValue={setLength}
            />
          </div>
          <div className="w-full p-2">
            <TextInput
              title="Weight"
              placeholder="Enter weight"
              inputValue={weight}
              setInputValue={setWeight}
            />
          </div>
        </section>

        <Button
          htmlType="submit"
          className="bg-teal-800 w-full mt-[7px] text-white font-semibold py-2 px-4 border border-gray-400 rounded shadow hover:bg-white hover:text-teal-800"
          loading={isProcessing}>
          {isProcessing
            ? isUpdating
              ? "Updating..."
              : "Adding..."
            : isUpdating
            ? "Update Store"
            : "Add Store"}
        </Button>
      </Form>
    </Modal>
  );
};

export default WaterMachineModal;
